import moment from 'moment/moment';

const defaultFormat = 'YYYY-MM-DD';

export const today = moment().format(defaultFormat);
